import moment from "moment";
import { useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../core/common/datePicker";
import { activityDetails } from "../../../core/data/json/activitydetails";

interface NotificationProps {
  notificationsData: any;
}

const Notification: React.FC<NotificationProps> = ({ notificationsData }) => {
  const data = activityDetails;
  const [activityFilter, setActivityFilter] = useState<string | null>(null);

  const filteredData = activityFilter
    ? data.filter((item) => item.activity_type === activityFilter)
    : data;

  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "id",
      render: (text: string, record: any, index: number) => (
        <>
          <div>{index + 1}</div>
        </>
      ),
      width: 80,
    },
    {
      title: "Title",
      dataIndex: "title",
      render: (text: String) => (
        <p className="fs-14 text-dark fw-medium">{text}</p>
      ),
      //   sorter: (a: any, b: any) => a.title.length - b.title.length,
    },
    {
      title: "Status",
      dataIndex: "is_read",
      render: (value: boolean, record: any) => (
        <span
          className={`badge bg-opacity-10 ${
            value
              ? "bg-success text-success"
              : record.is_favourite
              ? "bg-warning text-warning"
              : "bg-primary text-primary"
          }`}
        >
          <i
            className={`ti me-1 ${
              value
                ? "ti-mail-opened"
                : record.is_favourite
                ? "ti-star"
                : "ti-mail"
            }`}
          />
          {value ? "Read" : record.is_favourite ? "Favourite" : "Unread"}
        </span>
      ),
      //   sorter: (a: any, b: any) =>
      //     a.activity_type.length - b.activity_type.length,
    },

    {
      title: "Activity Type",
      dataIndex: "action_type",
      render: (text: string, record: any) => (
        <span
          className={`badge ${
            text === "ATTENDANCE_VERIFICATION"
              ? "badge-pink-transparent"
              : text === "SHIFT_VERIFICATION"
              ? "badge-purple-transparent"
              : text === "Tasks"
              ? "badge-info-transparent"
              : "badge-warning-transparent"
          }`}
        >
          <i
            className={`ti  me-1 ${
              text === "ATTENDANCE_VERIFICATION"
                ? "ti-device-computer-camera"
                : text === "SHIFT_VERIFICATION"
                ? "ti-phone"
                : text === "Tasks"
                ? "ti-subtask"
                : "ti-mail"
            }`}
          />
          {text}
        </span>
      ),
      //   sorter: (a: any, b: any) =>
      //     a.activity_type.length - b.activity_type.length,
    },

    {
      title: "Created Date",
      dataIndex: "created_at",
      render: (text: string) => moment(text).format("DD-MM-YYYY hh:mm A"),
      //   sorter: (a: any, b: any) => a.created_date.length - b.created_date.length,
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: () => (
        <div className=" d-inline-flex gap-2">
          <Link to="#" className="">
            <i className="ti ti-eye" />
          </Link>
          <Link
            to="#"
            data-bs-toggle="modal"
            data-inert={true}
            data-bs-target="#delete_modal"
          >
            <i className="ti ti-trash" />
          </Link>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="card">
        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
          <h5>Notification List</h5>
          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
            <div className="me-3">
              <div className="input-icon-end position-relative">
                <PredefinedDateRanges />
                <span className="input-icon-addon">
                  <i className="ti ti-chevron-down" />
                </span>
              </div>
            </div>
            {/* Status */}
            <div className="dropdown me-3">
              <Link
                to="#"
                className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Status
              </Link>
              <ul className="dropdown-menu  dropdown-menu-end ">
                <li>
                  <Link to="#" className="dropdown-item rounded-1">
                    Read
                  </Link>
                </li>
                <li>
                  <Link to="#" className="dropdown-item rounded-1">
                    Unread
                  </Link>
                </li>
                <li>
                  <Link to="#" className="dropdown-item rounded-1">
                    Favourite
                  </Link>
                </li>
              </ul>
            </div>
            <div className="dropdown me-3">
              <Link
                to="#"
                className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                {activityFilter || "Activity Type"}
              </Link>
              <ul className="dropdown-menu  dropdown-menu-end p-3">
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                    onClick={() => setActivityFilter("Meeting")}
                  >
                    Meeting
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                    onClick={() => setActivityFilter("Calls")}
                  >
                    Calls
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                    onClick={() => setActivityFilter("Tasks")}
                  >
                    Tasks
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                    onClick={() => setActivityFilter("Email")}
                  >
                    Email
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                    onClick={() => setActivityFilter(null)}
                  >
                    Clear Filter
                  </Link>
                </li>
              </ul>
            </div>
            <div className="dropdown">
              <Link
                to="#"
                className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Sort By : Last 7 Days
              </Link>
              <ul className="dropdown-menu  dropdown-menu-end p-3">
                <li>
                  <Link to="#" className="dropdown-item rounded-1">
                    Recently Added
                  </Link>
                </li>
                <li>
                  <Link to="#" className="dropdown-item rounded-1">
                    Ascending
                  </Link>
                </li>
                <li>
                  <Link to="#" className="dropdown-item rounded-1">
                    Desending
                  </Link>
                </li>
                <li>
                  <Link to="#" className="dropdown-item rounded-1">
                    Last Month
                  </Link>
                </li>
                <li>
                  <Link to="#" className="dropdown-item rounded-1">
                    Last 7 Days
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="card-body p-0">
          <Table
            dataSource={notificationsData}
            columns={columns}
            Selection={false}
            handlePagination={(pagination) => {
              console.log("Pagination changed:", pagination);
            }}
          />
        </div>
      </div>
    </>
  );
};

export default Notification;
